import React, {useEffect, useRef} from 'react';
import styles from './ButtonLeftOriginals.scss';

const SHADOW_OVERRIDE_CSS = `
    :host {
        --css-position: relative !important;
        display: inline-block !important;
        overflow: visible !important;
    }
    [part="container"] {
        overflow: visible !important;
    }
    button.trigger-button[part="acsb-trigger"],
    button.trigger-button[data-testid="acsb-trigger"],
    .trigger-button[part="acsb-trigger"] {
        position: relative !important;
        inset: auto !important;
        top: auto !important;
        right: auto !important;
        bottom: auto !important;
        left: auto !important;
        margin: 0 !important;
        width: var(--bm-icon-size, 45px) !important;
        height: var(--bm-icon-size, 45px) !important;
    }
`;

const ButtonLeftOriginals = ({className = ''}) => {
	const slotRef = useRef(null);

	useEffect(() => {
		const slot = slotRef.current;
		if (!slot) return;

		const adoptedNodes = new Set();

		const adopt = (node) => {
			if (!node || adoptedNodes.has(node)) return;
			adoptedNodes.add(node);
			node.style.setProperty('position', 'static', 'important');
			node.style.setProperty('inset', 'auto', 'important');
			node.style.setProperty('margin', '0', 'important');
			node.style.setProperty('transform', 'none', 'important');
			node.style.setProperty('pointer-events', 'auto', 'important');
			slot.appendChild(node);
		};

		const findIubenda = () => document.querySelector('button.iubenda-tp-btn');

		const findAcsbWidget = () => {
			const widgets = document.querySelectorAll('access-widget-ui');
			for (const w of widgets) {
				if (w.shadowRoot && w.shadowRoot.querySelector('[data-testid="acsb-trigger"]')) {
					return w;
				}
			}
			return null;
		};

		const injectShadowOverride = (widget) => {
			if (!widget || !widget.shadowRoot) return;
			if (widget.shadowRoot.querySelector('style[data-blo-override]')) return;
			const style = document.createElement('style');
			style.setAttribute('data-blo-override', '');
			style.textContent = SHADOW_OVERRIDE_CSS;
			widget.shadowRoot.appendChild(style);
		};

		const enforceOrder = () => {
			const acsb = slot.querySelector(':scope > access-widget-ui');
			const iub = slot.querySelector(':scope > button.iubenda-tp-btn');
			// искаме: accessibe ПЪРВО (горе), iubenda ВТОРО (долу)
			if (acsb && iub && (acsb.compareDocumentPosition(iub) & Node.DOCUMENT_POSITION_PRECEDING)) {
				slot.insertBefore(acsb, iub);
			}
		};

		const tryAdoptAll = () => {
			const acsb = findAcsbWidget();
			adopt(acsb);
			injectShadowOverride(acsb);

			const iub = findIubenda();
			adopt(iub);
			if (iub) {
				iub.style.setProperty('width', 'var(--bm-iubenda-size, 45px)', 'important');
				iub.style.setProperty('height', 'var(--bm-iubenda-size, 45px)', 'important');
				iub.style.setProperty('min-width', '0', 'important');
				iub.style.setProperty('background-size', 'contain', 'important');
				iub.style.setProperty('background-position', 'center', 'important');
				iub.style.setProperty('background-repeat', 'no-repeat', 'important');
			}

			enforceOrder();
		};

		tryAdoptAll();

		const observer = new MutationObserver(() => tryAdoptAll());
		observer.observe(document.body, {childList: true, subtree: true});

		return () => {
			observer.disconnect();

			// Move adopted nodes to a hidden parking spot instead of restoring them.
			// Prevents accessibe / iubenda from flashing back to their default
			// positions during SPA route changes (between unmount and next mount).
			let parking = document.getElementById('__blo-parking');
			if (!parking) {
				parking = document.createElement('div');
				parking.id = '__blo-parking';
				parking.style.display = 'none';
				document.body.appendChild(parking);
			}
			adoptedNodes.forEach((node) => {
				parking.appendChild(node);
			});
		};
	}, []);

	return (
	  <div className={className}>
		  <div ref={slotRef} className={styles.container}/>
	  </div>
	);
};

export default ButtonLeftOriginals;